import axios from "axios";
import classNames from "classnames";
import React, { useContext, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";

import Flex from "../../components/common/Flex";
import logo from "../../assets/img/illustrations/falcon.png";
import Section from "../../components/common/Section";
import { AppContext } from "../../context/AppContext";

const ReEnableAccount = () => {
  const { user } = useContext(AppContext);

  const [accountName, setAccountName] = useState("");
  const [userType, setUserType] = useState("g-user");
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const setFormattedContent = React.useCallback(
    (text) => {
      setContent(text.slice(0, 200));
    },
    [setContent],
  );
  const submitHandler = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    !accountName && toast.error("Account Name is required");
    !email && toast.error("Email is required");
    !content && toast.error("Message is required");
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}reEnableRequest`,
        {
          name: accountName,
          email: email,
          userType: userType,
          message: content,
        },
      );
      if (await res?.data?.success) {
        toast.success("Request sent successfully");
        setAccountName("");
        setEmail("");
        setContent("");
        setUserType("g-user");
        setIsLoading(false);
      } else {
        if (res?.data?.message) {
          toast.error(res?.data?.message);
        }
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("Something went wrong!");
      setIsLoading(false);
    }
  };
  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={12} md={8} lg={6} xl={6} className="col-xxl-4 ">
          <Flex justifyContent="center" alignItems="center" className="mb-4">
            <a
              href={user?.isUserLoggedIn ? "/" : "https://ideaclip.com.au/home"}
              className={classNames("text-decoration-none")}>
              <div className={classNames("d-flex")}>
                <span className={""}>
                  <img className="me-2" src={logo} alt="Logo" width={200} />
                </span>
              </div>
            </a>
            {/* <Logo width={200} /> */}
          </Flex>
          <Card>
            <Card.Header className="text-center  mt-3">
              <h5>Request for Reactivation of My Account</h5>
              <div
                className="alert alert-primary mt-4"
                style={{ fontSize: "0.875rem" }}>
                Please state your relevant reasons why IDEACLIP should consider
                reactivation of your account. It may take up to 5 working days
                for us to respond to your request.
              </div>
            </Card.Header>
            <Card.Body className="bg-light">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Account Username</Form.Label>
                  <Form.Control
                    placeholder={"Account Username"}
                    name="Account Name"
                    type="text"
                    value={accountName}
                    onChange={(e: any) =>
                      setAccountName(e.target.value.toLowerCase().trim())
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>User Type</Form.Label>
                  <Form.Control
                    as={"select"}
                    placeholder={"User Type"}
                    name="User Type"
                    type="text"
                    value={userType}
                    onChange={(e: any) => setUserType(e.target.value)}>
                    <option value={"g-user"}>General</option>
                    <option value={"b-user"}>Business</option>
                    <option value={"c-user"}>Charity</option>
                  </Form.Control>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    placeholder={"Email address"}
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e: any) => setEmail(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    placeholder={"Message"}
                    name="email"
                    as="textarea"
                    rows={6}
                    onChange={(event) =>
                      setFormattedContent(event.target.value)
                    }
                    value={content}
                  />
                  <p
                    className="w-100 mt-1"
                    style={{
                      textAlign: "end",
                      fontSize: "0.875rem",
                      color: "rgb(125, 138, 155)",
                    }}>
                    {content.length}/200
                  </p>
                </Form.Group>

                <Form.Group>
                  <Button
                    // type="submit"
                    onClick={(e: any) => submitHandler(e)}
                    color="primary"
                    className="mt-1 w-100"
                    disabled={!accountName || !email || !content || isLoading}>
                    {isLoading ? "Submitting" : "Submit"}
                  </Button>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default ReEnableAccount;
